<button mat-menu-item type="button" [disabled]="disabled" (click)="primecapButtonMenuClick()">
  {{label}}
</button>
